import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export function fieldErrorId(controlId: string): string {
  return `${controlId}-error`;
}

export interface FieldErrorProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
}

export function FieldError({
  id,
  className,
  children,
  ...props
}: FieldErrorProps) {
  return (
    <p
      id={id}
      role="alert"
      className={cn("mt-1.5 text-sm text-error-600", className)}
      {...props}
    >
      {children}
    </p>
  );
}
